import React, {useState,useEffect} from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import useIdleTimeout from './components/IdleTimeoutContainer'
import Preloader from './components/Preloader';
import { useTranslation } from 'react-i18next';
import { useDataLayer } from 'react-common-gdlv2';
import { getBackToAppLink, getQueryParams, getDeviceBrowser, validateUserFetchCard } from './utils/utils';

const Cardview = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const browser = getDeviceBrowser();
    const { track } = useDataLayer();
    const [loading, setLoading] = useState(true);

    const [cardHolderName,setCardHolderName] = useState('');
    const [cardNumber,setCardNumber] = useState('');
    const [expiryMonth,setExpiryMonth] = useState('');
    const [expiryYear,setExpiryYear] = useState('');

    // fill the form with card details
    function populateCardDetailsInSaFari(data) {
        document.getElementById("cc-name").value = t(data.cardHolderName);
        document.getElementById("cc-number").value = t(data.cardNumber);
        document.getElementById("cc-exp-month").value = t(data.expiryDate.slice(0,2));
        document.getElementById("cc-exp-year").value = t(data.expiryDate.slice(2));
    }
    const params = getQueryParams();
     
    const token = params && params.token ? params.token : "";

    const queryParams = new URLSearchParams(location.search);

    const cookieGroups = queryParams.get("cookieGroups");
    const C0001 = queryParams.get("C0001");
    const C0002 = queryParams.get("C0002");
    const C0003 = queryParams.get("C0003");
    const C0004 = queryParams.get("C0004");
    const C0009 = queryParams.get("C0009");
    const adobe_mc = queryParams.get("adobe_mc");

    let getAllQueryParams = "";

    if (queryParams.get("cookieGroups")!=null) {
        getAllQueryParams = `?cookieGroups=${cookieGroups}&C0001=${C0001}&C0002=${C0002}&C0003=${C0003}&C0004=${C0004}&C0009=${C0009}&adobe_mc=${adobe_mc}`;
    }

    useEffect(() => {
        if(token.length > 0){
            navigate(`/displayCard${getAllQueryParams}`,{
                state: {tokenInState:token}
            });
        }
    },[token, navigate, getAllQueryParams]);

    let tokenInState = '';

    if(location.state !== null && location.state !== "undefined" && location.state.tokenInState.length  > 0 ){
        tokenInState = location.state.tokenInState;
    }

    //Disable User right click action
    const handleContextMenu = (event) => {
        event.preventDefault();
    }
    useEffect(() => {
        document.addEventListener('contextmenu', handleContextMenu);
        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
        };
    },[]);

    //checking user IdleTime for 3 min, if not active redirection to timeout page 
    const {isIdle} = useIdleTimeout();
    useEffect(() => {   
        if(isIdle) {
            if(location.state !== null && location.state !== "undefined" && location.state.tokenInState.length  > 0 ){
                location.state.tokenInState = '';
            }
            navigate('/timeout');
        }
    // eslint-disable-next-line
    },[isIdle,navigate]);

    useEffect(() => {   
        if(tokenInState.length > 0){
         validateUserFetchCard(tokenInState)
             .then((data) => {
                setLoading(false);
                if(browser === "Safari"){
                    populateCardDetailsInSaFari(data);
                }
                setCardHolderName(data.cardHolderName);
                setCardNumber(data.cardNumber);
                setExpiryMonth(data.expiryDate.slice(0,2));
                setExpiryYear(data.expiryDate.slice(2));
             })
             .catch(() => {
                setLoading(false);
                navigate('/errorPage');
             });
         }

        // If there is no token , Navigate to not authorized page
        if(tokenInState.length === 0 && token.length === 0){
            navigate('/errorPage',{
                state: {noToken:true}
            });
        }
        // eslint-disable-next-line
       },[navigate, token, browser, tokenInState]);
   
    
    const handleBackToApp = () => {
        track('CLICK: BACK TO APP BUTTON', null,null);
        window.location = getBackToAppLink();
    };

    let showCard = !loading && cardNumber.length > 0 ? 'visible' : 'hidden';
    
return (
    <>
    {loading && <Preloader/> }
    <div style={{visibility:showCard}}>
    <h1 className='headerTxt'>{t('Add your details to your browser')}</h1>
    <form action="/confirmation" id="card-autofill-form" autoComplete="on">
    <div className="zb-card card-outline">
        {browser === "Safari" ? 
        <>
            <div className="customized-label">
                <div><label className="card-label">Cardholder name</label></div>
                <div>
                    <input 
                        name="cc-name" 
                        id="cc-name" 
                        autoComplete="cc-name" 
                        className="customized-input ctHidden" 
                        aria-label={t("Card Holder Name")}
                        aria-required="true"
                    />
                </div>
            </div>
            <div className="customized-label">
                <div><label className="card-label">Card number</label></div>
                <div>
                    <input 
                        name="cc-number" 
                        id="cc-number" 
                        autoComplete="cc-number" 
                        className="customized-input ctHidden" 
                        aria-label={t("Card Number")}
                        aria-required="true"
                    />
                </div>
            </div>
            <div className="customized-label">
                <div><label className="card-label">Exp date</label></div>
                <div>
                    <input 
                        name="cc-exp-month" 
                        id="cc-exp-month" 
                        autoComplete="cc-exp-month" 
                        className="customized-input exp-date ctHidden" 
                        aria-label={t("Expiry Month")}
                        aria-required="true"
                    />/&nbsp;
                    <input 
                        name="cc-exp-year" 
                        id="cc-exp-year" 
                        autoComplete="cc-exp-year"  
                        className="customized-input exp-date ctHidden" 
                        aria-label={t("Expiry Year")}
                        aria-required="true"
                    />
                </div>
            </div>
        </>
        : 
        <>
            <div className="customized-label">
                <div><label className="card-label">Cardholder name</label></div>
                <div>
                    <input 
                        name="cc-name" 
                        id="cc-name" 
                        autoComplete="cc-name" 
                        className="customized-input ctHidden" 
                        aria-label={t("Card Holder Name")}
                        value= {t(cardHolderName)} 
                        onChange={(e)=> setCardHolderName(e.target.value)} 
                        aria-required="true"
                    />
                </div>
            </div>
            <div className="customized-label">
                <div><label className="card-label">Card number</label></div>
                <div>
                    <input 
                        name="cc-number" 
                        id="cc-number" 
                        autoComplete="cc-number" 
                        className="customized-input ctHidden" 
                        aria-label={t("Card Number")}
                        value={t(cardNumber)}
                        onChange={(e)=> setCardNumber(e.target.value)}
                        aria-required="true"
                    />
                </div>
            </div>
            <div className="customized-label">
                <div><label className="card-label">Exp date</label></div>
                <div>
                    <input 
                        name="cc-exp-month" 
                        id="cc-exp-month" 
                        autoComplete="cc-exp-month" 
                        className="customized-input exp-date ctHidden" 
                        aria-label={t("Expiry Month")}
                        value={t(expiryMonth)} 
                        onChange={(e)=> setExpiryMonth(e.target.value)}
                        aria-required="true"
                    />/&nbsp;
                    <input 
                        name="cc-exp-year" 
                        id="cc-exp-year" 
                        autoComplete="cc-exp-year"  
                        className="customized-input exp-date ctHidden" 
                        aria-label={t("Expiry Year")}
                        value={t(expiryYear)} 
                        onChange={(e)=> setExpiryYear(e.target.value)}
                        aria-required="true"
                    />
                </div>
            </div>
        </>
        }
            {/* overlay div to disable user interaction */}
            <div name="transparent-overlay" className="overlay-child"></div>
        </div>
        <div className="card-buttons">
            <input type="submit" 
            value={t('Continue')} 
            onClick={() =>
                track(
                  'SUBMIT: CONTINUE BUTTON',
                  null,
                  null
                )
            }
            className="zb-button zb-button-primary"/>
        </div>
        <div className="card-buttons">
            <input aria-label="Back to app" type="button" value={t("Back to app")} onClick={handleBackToApp} className="zb-button zb-button-secondary"/>
        </div>
    </form>
    </div>
    </>
 )
}
export default Cardview